import { get, post, put, remove } from "../api_helper";
import * as url from "../url_helper";
const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const NpaPop =  ({employeeID,HrControl,NatureActionCode}) =>
  get(baseURL + url?.NPAPOPUP_BASE + `/${employeeID}/${HrControl}/${NatureActionCode}`);

